// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"59aa2433","182":"59ab3f30","292":"7a3c6b15","397":"35001101","453":"2bbdd1dc","502":"4c37f163","551":"1051aac6","869":"2c5dcc70"}[chunkId] + ".chunk.js";
};